export const selectGlobalsTranslations = (state) => state.globals.translations;
export const selectGlobalTranslation = (state, key) =>
  state.globals.translations[key]?.default;
